import * as Yup from 'yup';

import { Seller, SellerIntegrationSettings } from 'shared/types/Sellers';

export interface SellerIntegrationSettingsFormValues {
  // customerActivationMode: string;
  hasConsolidatedValidationCalls: boolean;
  hasCustomerPricing: boolean;
  hasCustomerInventory: boolean;
}

export const getSellerIntegrationSettingsFormValidationSchema = (
  t: (key: string) => string,
) =>
  Yup.object({
    // customerActivationMode: Yup.string().required(
    //   t('Customer Activation Mode is required.'),
    // ),
    hasConsolidatedValidationCalls: Yup.boolean().required(
      t('Has Consolidated Validation Calls is required.'),
    ),
    hasCustomerPricing: Yup.boolean().required(
      t('Has Customer Pricing is required.'),
    ),
    hasCustomerInventory: Yup.boolean().required(
      t('Has Customer Inventory is required.'),
    ),
  });

export const populateFormValuesFromSettings = (seller: Seller) => {
  return {
    // customerActivationMode: seller.customerActivationMode,
    hasConsolidatedValidationCalls: seller.hasConsolidatedValidationCalls,
    hasCustomerPricing: seller.hasCustomerPricing,
    hasCustomerInventory: seller.hasCustomerInventory,
  };
};

export const populateSettingsFromFormValues = (
  values: SellerIntegrationSettingsFormValues,
) => {
  let settingsToSave: SellerIntegrationSettings = {
    // customerActivationMode: values.customerActivationMode,
    hasConsolidatedValidationCalls: values.hasConsolidatedValidationCalls,
    hasCustomerPricing: values.hasCustomerPricing,
    hasCustomerInventory: values.hasCustomerInventory,
  };

  return settingsToSave;
};
